/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Uploading_SnapshotInputs */



/**
* | output |
* | --- |
* | "Uploading snapshot to storage..." |
*
* @param {Team_Sync_Status_Uploading_SnapshotInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_uploading_snapshot = /** @type {((inputs?: Team_Sync_Status_Uploading_SnapshotInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Uploading_SnapshotInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléversement du snapshot vers le stockage...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snapshot wird in den Speicher hochgeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dello snapshot nell'archivio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка снимка в хранилище...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando instantánea al almacenamiento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在将快照上传到存储设备...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スナップショットをストレージにアップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैपशॉट को स्टोरेज में अपलोड किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviando instantâneo para o armazenamento...")
	return /** @type {LocalizedString} */ ("Uploading snapshot to storage...")
});